var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1714 7.9482V0.500732H22.9237L31.555 6.5425C32.5925 7.36287 33.3522 8.42686 33.9084 9.59501H18.818C17.91 9.59501 17.1714 8.8562 17.1714 7.9482Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4764 21.5007C29.1315 21.5007 28.0412 20.4104 28.0412 19.0655C28.0412 17.7206 29.1315 16.6303 30.4764 16.6303C31.8213 16.6303 32.9116 17.7206 32.9116 19.0655C32.9116 20.4104 31.8213 21.5007 30.4764 21.5007Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11211 21.5006C5.76722 21.5006 4.67697 20.4104 4.67697 19.0655C4.67697 17.7206 5.76722 16.6304 7.11211 16.6304C8.45699 16.6304 9.54724 17.7206 9.54724 19.0655C9.54724 20.4104 8.45699 21.5006 7.11211 21.5006Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7731 7.9482V0.500732H16.1184V7.9482C16.1184 9.43666 17.3295 10.648 18.818 10.648H34.3493C35.6143 14.1398 35.3585 18.1653 35.226 19.4945H33.9354C33.9528 19.3536 33.9646 19.2111 33.9646 19.0656C33.9646 17.1422 32.3998 15.5771 30.4766 15.5771C28.5531 15.5771 26.9883 17.1422 26.9883 19.0656C26.9883 19.2111 27.0001 19.3536 27.0175 19.4945H10.5709C10.5883 19.3536 10.6 19.2111 10.6 19.0656C10.6 17.1422 9.03524 15.5771 7.11207 15.5771C5.33953 15.5771 3.87466 16.9077 3.65553 18.6218H0.917053V10.648H10.0736C11.562 10.648 12.7731 9.43666 12.7731 7.9482Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7198 0.500732V7.9482C11.7198 8.8562 10.9813 9.59501 10.0733 9.59501H0.916791V0.500732H11.7198Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleWhite);
export default __webpack_public_path__ + "static/media/vehicle-white.06eb5a67ec66c14e6732ea61ea2acd20.svg";
export { ForwardRef as ReactComponent };